import Box from '@spotnana/pixel-react/dist/Box';
import spotnanaTheme from '@spotnana/pixel-react/dist/utils/themes/theme';
import Typography from '@spotnana/pixel-react/dist/Typography';
import { CSSObject } from 'styled-components';

const ErrorLabel = ({
  message,
  dataTestId,
  labelStyles,
  className,
}: {
  message: string;
  dataTestId?: string;
  labelStyles?: CSSObject;
  className?: string;
}): JSX.Element => (
  <Box mt="4px" style={labelStyles} className={className}>
    <Typography
      variation="label"
      lineHeight={spotnanaTheme.lineHeights.label}
      color={spotnanaTheme.colors.error}
      data-testid={dataTestId}
    >
      {message}
    </Typography>
  </Box>
);

export default ErrorLabel;
